import { handleTouchEvents } from '../utilities/touchEvent'

document.addEventListener('DOMContentLoaded', () => {
  handleTouchEvents('[data-mp-block-type="horoscope_carousel_block"] .block__main')
})
